import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router'
import { Box, Divider, Grid, Typography } from '@material-ui/core'
import { useStyles } from './style'
import { programService } from '../../Services'
import { AppButton, Breadcrumb, DisplayMessage, Loader } from '../../Components'
import { Cards } from '../../elements'
import _ from 'lodash'
import * as messageTypes from '../../utils/messageTypes'
import { paymentOptions, programData } from './viewapplicationconstant'
import download from '../../Assets/Images/download.svg'
import pdfIcon from '../../Assets/Images/pdfIcon.svg'
import { trimNameWithoutExtension } from '../../utils/fileUtils'
import DownloadFile from '../../utils/downloadFile'
import { applicationStatus, SITEREJECTED, steps } from './constant'
import CustomStepper from '../../Components/CustomStepper'
import StatusButton from '../../Components/StatusButton'
import moment from 'moment'
import Error404 from '../ErrorPages/Error404'

const ViewApplication = (props) => {
  const classes = useStyles()
  const [application, setApplication] = useState({})
  const [program, setProgram] = useState({})
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [loading, setLoading] = useState(false)

  const { currentUser } = props
  const { programId, applicationId } = useParams()

  const getProgram = () => {
    programService.getProgramsById(currentUser.account_id, programId)
      .then(programData => {
        setProgram(programData)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getApplication = () => {
    setLoading(true)
    programService.getApplicationById(currentUser.account_id, programId, applicationId)
      .then(applicationData => {
        setLoading(false)
        setApplication(applicationData)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const renderViewSystem = () => (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Box className={classes.formCardHeading} p={1}>Application details</Box>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6}>
              {programData.details.left.map(data => (
                data.rejected ?
                  application && application.log_history && application.log_history.length > 0 && application.log_history[application.log_history.length - 1].application_status === SITEREJECTED && (
                    <Box mx={1} my={2}>
                      <Box className={classes.listKey}>{data.label}</Box>
                      <Box className={classes.listValue}>{application && moment(application.log_history[application.log_history.length - 1].timestamp).tz(props.timeZone).format('DD MMMM, YYYY (hh:mm A)')}</Box>
                    </Box>
                  ) :
                  <Box mx={1} my={2}>
                    <Box className={classes.listKey}>{data.label}</Box>
                    <Box className={classes.listValue}>{_.get(application, data.path, '-')}</Box>
                  </Box>
              ))}
            </Grid>
            <Grid item xs={12} sm={6}>
              {programData.details.right.map(data => (
                data.rejected ?
                  application && application.log_history && application.log_history.length > 0 && application.log_history[application.log_history.length - 1].application_status === SITEREJECTED && (
                    <Box mx={1} my={2}>
                      <Box className={classes.listKey}>{data.label}</Box>
                      <Box className={classes.listValue}>{application && moment(application.log_history[application.log_history.length - 1].timestamp).tz(props.timeZone).format('DD MMMM, YYYY (hh:mm A)')}</Box>
                    </Box>
                  ) :
                  <Box mx={1} my={2}>
                    <Box className={classes.listKey}>{data.label}</Box>
                    <Box className={classes.listValue}>{data.id === 'paymentOption' ? paymentOptions[_.get(application, data.path, '-')] : _.get(application, data.path, '-')}</Box>
                  </Box>
              ))}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box className={classes.formCardHeading} p={1}>Files Uploaded</Box>
          {programData.files.map(file => (
            <Box className={classes.applicationFile} mx={1} my={2}>
              <img src={pdfIcon} alt="" />
              <Box className={classes.fileHelperText} mt={2}>
                {file.label}
              </Box>
              <Box className={classes.viewFileName} onClick={() => { application && application[file.path] && DownloadFile(application[file.path]) }}>
                {application && application[file.path] ?
                  <Box className={classes.fileEdit}>
                    <img src={download} className={classes.downloadIcon} alt="" />
                    {trimNameWithoutExtension(application[file.path].split('/')[application[file.path].split('/').length - 1])}
                  </Box>
                  : ''}
              </Box>
            </Box>
          ))}
          {application && application.log_history && application.log_history.length > 0 && application.log_history[application.log_history.length - 1].application_status === SITEREJECTED && (
            <>
              <Box className={classes.formCardHeading} p={1} mt={3}>Reason for Rejection</Box>
              <Box m={1} pb={5} className={classes.siteDetail}>
                {application.log_history[application.log_history.length - 1].message}
              </Box>
            </>
          )}
        </Grid>
      </Grid>
      <Divider />
      <Box display="flex" justifyContent="flex-end">
        <Box minWidth="200px">
          <AppButton text="Back" fill={false} onClick={() => props.history.push(`/programs/${programId}/systems-addition`)} />
        </Box>
      </Box>
    </>
  )

  useEffect(() => {
    getProgram()
  }, [])

  useEffect(() => {
    getApplication()
  }, [])

  const getBreadcrumbs = () => {
    let value = [{ 'Home': '/' }, { 'Programs': '/programs' }]
    if (program) {
      value.push({ [program?.program_name_admin_ui]: `/programs/${program.id}` })
      value.push({ 'Systems Addition': `/programs/${program.id}/systems-addition` })
      value.push({ 'View Application': '' })
    } else {
      value.push({ 'View Application': '' })
    }
    return value
  }

  if (program && program.feature_flags && program.feature_flags.system_enrollment_option !== 'SYSTEM_ADDITION') {
    return (<Error404 />)
  }

  return (
    <Box>
      <Breadcrumb value={getBreadcrumbs()} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      <Loader loading={loading} />
      <Box className={classes.headerWrapper} display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap">
        <Box display="flex" alignItems="center" flexWrap="wrap">
          <Typography className={classes.subPageTitle}>{`Application for Site ID : ${application ? application.site_id : ''}`}</Typography>
          {_.get(application, 'application_status', '') && <StatusButton color={applicationStatus[application?.application_status][1]} text={applicationStatus[application?.application_status][0]} />}
        </Box>
        {application && application.application_status === SITEREJECTED && <Box><AppButton text="Edit and Resubmit" fill={false} onClick={() => props.history.push({ pathname: `/programs/${programId}/systems-addition/application-form`, state: { application: application } })} /></Box>}
      </Box>
      <Box className={classes.stepperContainer}>
        <CustomStepper steps={steps} currentStep={!_.isEmpty(application) && applicationStatus[application.application_status][2]} status={!_.isEmpty(application) && application.application_status} />
      </Box>
      <Cards className={classes.cardWrapper} children={renderViewSystem()} />
    </Box>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin, isAdmin, timeZone } = auth
  return { currentUser, isSuperAdmin, isAdmin, timeZone }
}

export default connect(mapStateToProps, {})(ViewApplication)